module.exports = "../../../../platform/assets/pageMainIcon/industry_yewushezhilei4.svg";